import React from 'react'

const SignUp = () => {

  const google_api_key ="AIzaSyAR8DXVdBau3oOT5ly6yq3wTUpzUuz05TQ"
  return (
    <div>SignUp</div>
  )
}

export default SignUp